import React from 'react';
import logo from 'assets/logo-black.svg';
import gammaLogo from 'assets/amazon-logo_black.svg';
import { Img } from 'react-image';
import { StyledSection } from './styles';
import { getEnv } from '@xbcb/ui-utils';
import { UiStage } from '@xbcb/ui-types';

type LogoProps = {
  url?: string;
};
const Logo = ({ url }: LogoProps): React.ReactElement => {
  const loginUrl = url || '';
  const { stage } = getEnv();
  const isGammaOrLocal = stage === UiStage.GAMMA || stage === UiStage.LOCAL;

  return (
    <StyledSection>
      <Img
        src={isGammaOrLocal ? [gammaLogo] : [loginUrl, logo]}
        alt="INLT Logo"
      />
    </StyledSection>
  );
};

export default Logo;
